// extracted by mini-css-extract-plugin
export default {"zoomModal":"s4-z"};